<ul class="list bg-base-100 rounded-box shadow-md" sticky>
  <!-- <li class="p-4 pb-2 text-xs opacity-60 tracking-wide">
  	Most played songs this week
  </li> -->
  <li class="list-row">
    <div>
    	<img class="size-10 rounded-box" [altImg]="getImgBinder()"/>
    </div>
    <div>
      <div>
      	{{binder()?.name || 'Non référencé'}}
      </div>
      <div class="text-xs uppercase font-semibold opacity-60">
      	{{((binder())? '#'+uBinder().ident : 'Pas de code')}}
      </div>
    </div>

    @if(admin()){
	    <div class="add-btn-container">
				<button (click)="setScan()" class="btn btn-primary btn-gradient litle-btn-gradient">
					<i class="add-item fa-regular fa-grid-2-plus"></i>
				</button>
			</div>

	    <div class="dropdown dropdown-end">
				<div tabindex="0" role="button" class="btn text-primary m-1">
					<i class="fa-sharp fa-regular fa-ellipsis-vertical"></i>
				</div>
				<ul tabindex="-1" class="dropdown-content bg-base-100 rounded-box z-1 w-52 p-2 shadow-sm">
					<li class="px-2 py-1">
						<a (click)="toggleFavoriteBinder()">
			  				<i [ngClass]="{'fa-solid': uBinder()?.isFavorite, 'fa-light': !uBinder()?.isFavorite}" class="fa-light fa-bookmark pr-2"></i> Favoris
						</a>
					</li>
					<li class="px-2 py-1">
						<lgb-share [element]="uBinder()" typeElement="binder">
							<span>
			  				<i class="fa-light fa-paper-plane pr-2"></i> Partager
			  			</span>
			  		</lgb-share>
					</li>
					<li class="px-2 py-1">
						<a (click)="rmBinder()" class="text-error">
		  				<i class="fa-light fa-trash pr-2"></i> Supprimer
		  			</a>
					</li>
				</ul>
			</div>
		}
  </li>
</ul>